"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var interval_1 = require("../util/interval");
var pretty_1 = require("../util/pretty");
/**
 * 计算线性的 ticks，使用 R's pretty 方法
 * @param cfg 度量的配置项
 * @returns 计算后的 ticks
 */
function linearPretty(cfg) {
    var min = cfg.min, max = cfg.max, tickCount = cfg.tickCount, tickInterval = cfg.tickInterval;
    if (tickInterval) {
        return interval_1.default(min, max, tickInterval).ticks;
    }
    return pretty_1.default(min, max, tickCount).ticks;
}
exports.default = linearPretty;
//# sourceMappingURL=r-prettry.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/scale/lib/tick-method/r-prettry.js
// module id = 1079
// module chunks = 37